// extracted by mini-css-extract-plugin
export default {"chatButton":"SupportChatFacade_chatButton__A6K5r","chatContainer":"SupportChatFacade_chatContainer__8Pds5","chatIcon":"SupportChatFacade_chatIcon__VrtiN"};